// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"11":"ad206ffb","200":"30da7183","212":"c4153b3e","455":"c4d5dbfc","466":"92312fec","563":"a5e9cf72","962":"09bec20c"}[chunkId] + ".js";
};